var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-login__btn"},[_c('div',{staticClass:"c-btn c-btn--login"},[_c('button',{attrs:{"type":"button"},on:{"click":function($event){return _vm.handleClick()}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }